import { Injectable } from '@angular/core';
import { IGetBookingsStayResponse, ITraveller } from "libraries/service/resources/booking/interfaces/IGetBookings";
import { IStayPriceColsHeaders, IStayPriceColsHeadersTraveller } from "../interfaces/stay-price-cols-headers";
import { ColsNamesEnum } from "../interfaces/cols-names.enum";
import { Yii } from "libraries/interfaces/Yii";
import { TravellerDataTranslationService } from "libraries/service/traveller-data-translation/traveller-data-translation.service";

@Injectable()
export class ColsHeaderMappingService {

    constructor(
        private readonly travellerDataTranslationService: TravellerDataTranslationService,
    ) {
    }

    public generateColsHeaders(booking: Partial<IGetBookingsStayResponse>): IStayPriceColsHeaders {

        const travellers: IStayPriceColsHeadersTraveller[] = (booking.traveller || [])
            .map((traveller: ITraveller) => {
                return {
                    id: traveller.xId,
                    name: traveller ? this.travellerDataTranslationService.getTravellerIdentity(traveller): ""
                };
            });
        return {
            [ColsNamesEnum.title]: '',
            [ColsNamesEnum.total]: Yii.t('wui-shared-js', 'Total'),
            [ColsNamesEnum.traveller]: travellers
        };
    }
}